/**
 * Форматирует телефонный номер согласно международным стандартам
 * @param {string} phone -
 * @returns {string} -
 */
function getFormatPhoneNumber(phone: string): string {
  if (!phone || !window.COUNTRY_DATA) {
    return phone
  }

  const phoneMask = getPhoneMask()

  if (!phoneMask) {
    return phone
  }

  const phoneDigits = getPhoneDigits(phone)
  const phoneCode = getPhoneCode(phoneDigits)

  if (!isValidPhoneLength(phoneCode, phoneDigits)) {
    return phone
  }

  if (!isDigitsMatchMask(phoneDigits, phoneMask)) {
    return phone
  }

  const formattedPhone = applyPhoneMask(phoneDigits, phoneMask)

  return `${phoneCode} ${formattedPhone}`
}

function getPhoneMask() {
  return window.COUNTRY_DATA.phoneBodyMaskByCountryIso[window.COUNTRY_DATA.iso.toLowerCase()]
}

function getPhoneDigits(phone: string) {
  return removeCountryCode(phone.replace(/\D/g, ''))
}

function getPhoneCode(phoneDigits: string) {
  const isRussian = window.COUNTRY_DATA.iso === 'RU'
  const startsWith800 = phoneDigits.startsWith('800')

  if (isRussian && startsWith800) {
    return '8'
  }

  return window.COUNTRY_DATA.phone.code
}

function removeCountryCode(phoneDigits: string) {
  const isRussian = window.COUNTRY_DATA.iso === 'RU'
  const startsWith8800 = phoneDigits.startsWith('8800')

  // Если номер российский и он начинается на 8800, то удаляем первую цифру
  if (isRussian && startsWith8800) {
    return phoneDigits.slice(1)
  }

  const countryPhoneCode = window.COUNTRY_DATA.phone.code.replace(/\D/g, '')

  // Иначе удаляем код телефона текущей страны, если он присутствует в номере
  return phoneDigits.startsWith(countryPhoneCode)
    ? phoneDigits.slice(countryPhoneCode.length)
    : phoneDigits
}

function isValidPhoneLength(phoneCode: string, phoneDigits: string) {
  const phoneCodeDigits = phoneCode.replace(/\D/g, '')
  const totalLengthPhone = phoneCodeDigits.length + phoneDigits.length
  const { minLength, maxLength } = window.COUNTRY_DATA.phone

  return totalLengthPhone >= minLength && totalLengthPhone <= maxLength
}

// Проверяет, соответствует ли количество цифр в номере количеству звёздочек в маске
function isDigitsMatchMask(phoneDigits: string, phoneMask: string): boolean {
  return phoneDigits.length === (phoneMask.match(/\*/g) || []).length
}

function applyPhoneMask(phoneDigits: string, phoneMask: string): string {
  let i = 0

  return phoneMask.replace(/\*/g, () => phoneDigits[i++] || '')
}

// todo: После выпиливания pd_fix_ydoc_phone_2, переименовать без функцию V2
export default getFormatPhoneNumber
